export interface DashboardMaps {
  id: string;
  title: string;
  url: string;
  slug: string; // Friendly URL identifier
  sortOrder?: number;
}

export const DashboardMaps: DashboardMaps[] = [
  {
    id: '4cc725b60d2944ffbe35d2464bee150e',
    title: 'Location Intelligence',
    url: 'https://arcgis.accdata.org/server/home/item.html?id=4cc725b60d2944ffbe35d2464bee150e',
    slug: 'site-toolkit',
  },
  {
    id: '5867ce8c7c614878ad3dbf5416d75772',
    title: 'GBRA Eligibility Experience',
    url: 'https://arcgis.accdata.org/server/apps/experiencebuilder/experience/?id=5867ce8c7c614878ad3dbf5416d75772',
    slug: 'gbra-eligibility',
  },
];
